import { Injectable, inject } from '@angular/core';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';
import { IS_SEARCH_BOT } from '@lentau/ui-kit/core/tokens/is-search-bot';
import { ClientReloadPolicyService } from '../config/client-reload-policy.service';
import { RuntimeRecoveryOrchestratorService } from './runtime-recovery-orchestrator.service';
import { isChunkLoadError } from '@lentau/core/runtime-recovery/shared/chunk-load-error.utils';

@Injectable({
  providedIn: 'root',
})
export class ChunkLoadRecoveryService {
  private readonly browserApiSupportService: BrowserApiSupportService = inject(BrowserApiSupportService);
  private readonly isSearchBot: boolean = inject(IS_SEARCH_BOT);
  private readonly clientReloadPolicyService: ClientReloadPolicyService = inject(ClientReloadPolicyService);
  private readonly runtimeRecoveryOrchestratorService: RuntimeRecoveryOrchestratorService = inject(
    RuntimeRecoveryOrchestratorService
  );

  public tryRecover(error: unknown): void {
    if (this.browserApiSupportService.isServer()) {
      return;
    }

    if (this.isSearchBot) {
      return;
    }

    if (!this.clientReloadPolicyService.isChunkAutoReloadEnabled()) {
      return;
    }

    if (!isChunkLoadError(error)) {
      return;
    }

    this.runtimeRecoveryOrchestratorService.recover('chunk_load', error);
  }
}
